import { ElementTransformer } from "@lexical/markdown"

import { $createQuestionNode, $isQuestionNode, QuestionNode } from "../nodes/question/node"

export const QuestionTransformer: ElementTransformer = {
  type: "element",
  dependencies: [QuestionNode],
  regExp: /^<Question\s+.*\/>$/,
  replace: (parentNode, children, match) => {
    const fullMatch = match[0]
    const keyMatch = fullMatch.match(/question_key="([^"]+)"/)
    const labelMatch = fullMatch.match(/question_label="([^"]+)"/)

    if (keyMatch && labelMatch) {
      const key = keyMatch[1]
      const label = labelMatch[1]
      const questionNode = $createQuestionNode(key, label)

      parentNode.replace(questionNode)
    }
  },
  export: (node) => {
    if (!$isQuestionNode(node)) {
      return null
    }
    return `<Question question_key="${node.getQuestionKey()}" question_label="${node.getQuestionLabel()}" />`
  },
}
